import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import {Link, withRouter} from 'react-router-dom';
import Layout from '../../layout/Layout';
import * as applicationActions from '../../actions/applicationActionCreators';
import {useMount} from 'react-use';
import CityContacts from '../../components/CityContacts';
import CityContactsSelectCity from '../../components/CityContacts/SelectCity';

import './style.scss';
import './mobile.scss';

const ContactsPage = (props) => {
  const
    {current_city, contactsCity} = props.applicationState,
    selectedCity = contactsCity || current_city;

    useMount(() => {
    props.applicationActions.fetchCity(props.applicationState.current_city.id);
  });
  return (
    <Layout>
      <div className='container contacts-page'>
        <h1>Адреса в {selectedCity.name_preposition}</h1>
        <div className='two-cols-container'>
          <div className='two-cols-container__col two-cols-container__col_left'>
            <CityContactsSelectCity />
          </div>
          <div className='two-cols-container__col two-cols-container__col_right'>
            <CityContacts />
          </div>
        </div>
      </div>
    </Layout>
  );
}

const mapDispatchToProps = (dispatch) => {
    return {
      applicationActions: bindActionCreators(applicationActions, dispatch)
    };
  },

  mapStateToProps = ({applicationState, railsContext}) => {
    return {
      applicationState,
      railsContext
    };
  },

  withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
  );

export default withRouter(compose(withConnect)(ContactsPage));
